<template>
  <div class="mt-[85px] mb-[45px] flex flex-row items-center">
    <div class="bg-[#FF6900] mr-[12px] w-[10px] h-[60px]"></div>
    <div class="text-[60px] font-semibold text-[#000000] tracking-normal font-br-hendrix">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
const __sfc_main = {};
export default __sfc_main;
</script>

<style scoped>
/* BR Hendrix 字体 */
.font-br-hendrix {
  font-family: 'BR Hendrix', sans-serif;
}
</style>
